export default "__VITE_ASSET__DgWiA13L__"